import React, { FC } from 'react';
import { ConfigContext } from './ConfigContext';
import { FilterContext } from './FilterContext';
// import { SimulatorContext, SimulatorContextComponent } from './SimulatorContext';

interface props {
    children: React.ReactNode;
}

//ALL CONTEXT WRAPPERS
const GlobalProvider: FC<props> = ({ children }) => {
    return (
        <>
            <FilterContext>{children}</FilterContext>
        </>
    );
};

export default GlobalProvider;
